import type { SavedEmailTemplate } from "@redotech/redo-model/saved-email-template";
import { savedEmailTemplateSchema } from "@redotech/redo-model/saved-email-template";
import { SortDirection } from "@redotech/redo-model/tables/table";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getSavedEmailTemplates = {
  name: "getSavedEmailTemplates" as const,
  input: z.object({ sortDirection: createEnum(SortDirection).optional() }),
  output: z.object({
    data: z.array(savedEmailTemplateSchema as z.ZodType<SavedEmailTemplate>),
    paginationKey: z.string().optional(),
  }),
};
